// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8l-3";
export var contentContainer = "_8l-0";
export var editorContainer = "_8l-1";
export var quillInputForm = "_8l-2";
export var zoneDivider = "_8l-4";